<template>
  <Head :title="newsCategory.meta_title">
    <meta
      name="description"
      :content="newsCategory.meta_description"
    >
    <link
      rel="canonical"
      :href="localeRoute('frontend.categories.slug', [newsCategory.slug])"
    >
    <meta
      property="og:image"
      content="/frontend/assets/favicon/og-image.jpg"
    >
  </Head>

  <section class="category-hero py-8 relative">
    <img
      src="/frontend/assets/category.svg"
      class="absolute -top-[50px] -left-[10px] hidden lg:block"
    >
    <div class="container">
      <h1 class="text-5xl font-bold mb-3 text-center">
        {{ newsCategory.name }}
      </h1>

      <div
        v-if="newsCategory.content"
        class="flex flex-wrap text-center"
      >
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="newsCategory.content"
          class="w-full lg:w-1/2 lg:mx-auto text-gray-300"
          v-html="newsCategory.content"
        />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </div>
  </section>

  <section class="blogs relative bg-white py-10">
    <div class="container">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mt-6">
        <NewsItem
          v-for="(newsItem, i) in newsItems"
          :key="`news-item-${i}`"
          :news="newsItem"
        />
      </div>
      <div
        v-show="newsItems.length === 0"
        class="text-center text-2xl lg:text-5xl mt-4 md:mt-8"
      >
        {{ __('news-category.nothing') }}
      </div>
    </div>
  </section>
</template>

<script>
import NewsItem from '../../Components/NewsItem.vue';

export default {
  components: {
    NewsItem,
  },

  props: {
    newsCategory: {
      type: Object,
      required: true,
    },

    newsItems: {
      type: Array,
      required: true,
    },
  },
};
</script>
